import ProductBox from "@/screens/Welcome/common/ProductInfo/ProductBox";
import { CustomerType } from "@/types/customerType";
import { Product } from "@/types/enumerations";
import { Process } from "@/types/contract";

interface ProductInfoProps {
  customerType?: CustomerType;
  commodityName: string;
  product: Product;
  process: Process;
}

const ProductInfo = ({ customerType, commodityName, product, process }: ProductInfoProps) => {
  return (
    <div>
      <ProductBox process={process} commodityName={commodityName} product={product} />
    </div>
  );
};

export default ProductInfo;
